import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import CustomInput from "../../../components/CustomInput";
import CustomButton from "../../../components/CustomButton";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { selectState } from "../../../store/slices/themeSlice";
import { header2Styles } from "../../../assets/styles/header2";
import LabeledDropdown from "./LabeledDropdown";
import { uppercase } from "../../../utils";
import { FinancialInstitutionsType } from "../../../api/awsApis";

interface AddNewCategoryModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onAddCategory: (newCategory: Category) => void;
  existingData: FinancialInstitutionsType;
}
export interface Option {
  label: string;
  value: string;
}

export interface Category {
  name: string;
  apiProvider: string;
  api: {
    moneyhub: string;
    powens: string | number;
    yodlee: string;
  };
  status: string;
}

const AddNewCategoryModal: React.FC<AddNewCategoryModalProps> = ({
  isOpen,
  onCancel,
  onAddCategory,
  existingData,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const { theme } = useSelector(selectState);

  const classes = useCustomStyles(header2Styles, theme);

  const [categoryName, setCategoryName] = useState("");
  const [apiProvider, setApiProvider] = useState("Yodlee");
  const [yodleeId, setYodleeId] = useState("");
  const [moneyhubId, setMoneyhubId] = useState("");
  const [powensId, setPowensId] = useState("");
  const categories = [
    { key: "10", value: "cash", displayName: "Cash" },
    { key: "11", value: "collectibles", displayName: "Collectibles" },
    { key: "9", value: "card", displayName: "Credit Card" },
    { key: "1", value: "digital", displayName: "Digital" },
    { key: "7", value: "investment", displayName: "Investment" },
    { key: "4", value: "loan", displayName: "Loan" },
    { key: "5", value: "mortgage", displayName: "Mortgage" },
    { key: "2", value: "insurance", displayName: "Insurance" },
    { key: "8", value: "pension", displayName: "Retirement" },
    { key: "6", value: "real_estate", displayName: "Real Estate" },
    { key: "3", value: "othera", displayName: "Other Assets" },
    { key: "12", value: "otherl", displayName: "Other Liabilities" },
  ].sort((a, b) => a.displayName.localeCompare(b.displayName));
  const defaultAPI = [
    { key: "1", value: "Yodlee" },
    { key: "2", value: "Moneyhub" },
    { key: "3", value: "Powens" },
  ];
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onCancel]);

  const addCategoryToFinancialInstitution = () => {
    const newCategory: Category = {
      name: categoryName,
      apiProvider: uppercase(apiProvider),
      api: {
        powens: powensId,
        moneyhub: moneyhubId,
        yodlee: yodleeId,
      },
      status: "active",
    };
    const alreadyExists = existingData.categories.some(
      (cat) => cat.name.toLowerCase() === newCategory.name
    );

    if (alreadyExists) {
      alert("Category with this name already exists. Please edit it instead");
      return;
    }

    // ✅ Pass back to parent
    onAddCategory(newCategory);
    onCancel(); // close the modal
  };

  if (isOpen) {
    return (
      <div className={classes.overlay}>
        <div className={classes.modal} ref={modalRef}>
          <h2 className={classes.headerTextLogOutModal}>ADD NEW CATEGORY</h2>
          <LabeledDropdown
            label="Category"
            options={categories}
            initialState={""}
            handleSelect={(v) => setCategoryName(v as string)}
          />
          <LabeledDropdown
            label="Default API"
            options={defaultAPI}
            initialState={defaultAPI[0].value}
            handleSelect={(v) => setApiProvider(v as string)}
          />
          <CustomInput
            label={"Yodlee Connection ID"}
            name="yodleeId"
            type="text"
            value={yodleeId}
            onChange={(e) => setYodleeId(e.target.value)}
            // onChange={() => console.log("sds")}
            placeholder="Enter Connection ID"
          />

          <CustomInput
            label={"Moneyhub Connection ID"}
            name="moneyhubID"
            type="text"
            value={moneyhubId}
            onChange={(e) => setMoneyhubId(e.target.value)}
            placeholder="Enter Connection ID"
          />

          <CustomInput
            label={"Powens Connection ID"}
            name="powensId"
            type="text"
            value={powensId}
            placeholder="Enter Connection ID"
            onChange={(e) => setPowensId(e.target.value)}
          />

          <CustomButton
            title={"ADD"}
            name="addClientButton"
            handleClick={() => {
              addCategoryToFinancialInstitution();
            }}
            type="submit"
            loading={false}
            //   loading={loading}
            //   disabled={!formik.isValid || loading || !formik.dirty}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default AddNewCategoryModal;
